module.exports = __webpack_public_path__ + "static/media/0138_Medium.f1146a83.jpg";